import { render, staticRenderFns } from "./UVideo.vue?vue&type=template&id=0ba97cae&"
import script from "./UVideo.vue?vue&type=script&lang=js&"
export * from "./UVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports